import styled from "styled-components";

interface AreaUploadProps {
    $arrastando: boolean;
}

interface CartaoUploadProps {
    $status: "enviando" | "sucesso" | "erro";
}

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const AreaUpload = styled.div<AreaUploadProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 25px;
    padding: 30px;
    border-radius: 6px;
    border: 2px dotted ${({ theme }) => theme.colors.interfaceGray200};
    transition: all 0.3s ease;
    background-color: ${({ $arrastando, theme }) =>
        $arrastando ? theme.colors.primaryRed50 || "rgba(239, 68, 68, 0.08)" : "transparent"};
    border-color: ${({ $arrastando, theme }) =>
        $arrastando ? theme.colors.primaryRed400 || "#ef4444" : theme.colors.interfaceGray200};

    .icone-upload {
        width: 80px;
        height: 80px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme }) => theme.colors.interfacePure100};

        svg {
            width: 30px;
            height: 30px;

            path {
                color: ${({ theme }) => theme.colors.interfaceGray200};
            }
        }
    }

    .textos-upload {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;

        .principal {
            font-size: 16px;
            font-weight: 600;
            color: ${({ theme }) => theme.colors.interfaceText400};
        }

        .secundario {
            font-size: 12px;
            font-weight: 400;
            color: ${({ theme }) => theme.colors.interfaceGray400};
        }
    }

    .acoes-upload {
        width: 100%;

        button {
            width: 100%;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;

            svg {
                width: 16px;
                height: 16px;
            }
        }
    }
`;

export const CabecalhoLista = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    h2 {
        font-size: 16px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceText400};
        margin: 0;
    }

    p {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        background-color: rgba(0, 0, 100, 0.1);
        padding: 10px;
        border-radius: 10px;
        font-weight: 600;
    }
`;

export const ListaAnexos = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    container-type: inline-size;
`;

export const CartaoUpload = styled.div<CartaoUploadProps>`
    width: 100%;
    display: grid;
    grid-template-columns: 25px 1fr auto;
    align-items: center;
    gap: 5px;
    padding: 15px;
    border-radius: 6px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
    background-color: ${({ theme, $status }) => {
        if ($status === "erro") return theme.colors.primaryRed50 || "rgba(239, 68, 68, 0.05)";
        if ($status === "sucesso") return theme.colors.secondaryGreen50 || "rgba(34, 197, 94, 0.05)";
        return theme.colors.primaryRed50 || "rgba(239, 68, 68, 0.05)";
    }};
    transition: background-color 0.3s ease;

    @container (max-width: 800px) {
        align-items: flex-start;
    }

    .icone {
        svg {
            width: 18px;
            height: 18px;
        }
    }

    .detalhes {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .cabecalho {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;

            @container (max-width: 800px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
            }

            .nome {
                font-size: 13px;
                font-weight: 600;
                color: ${({ theme }) => theme.colors.interfaceText400};
                word-break: break-word;
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .extensao {
                background-color: ${(props: any) => props.theme.colors.interfacePure0};
                color: ${(props: any) => props.theme.colors.c374151};
                padding: 3px 8px;
                border-radius: 12px;
                box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
                font-size: 10px;
                font-weight: 500;
            }
        }

        .rodape {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 4px;
            font-size: 11px;
            color: ${({ theme }) => theme.colors.interfaceGray400};

            @container (max-width: 800px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;

                svg {
                    display: none;
                }
            }

            span {
                display: flex;
                align-items: center;
                gap: 4px;
            }

            .mensagem-erro {
                color: ${({ theme }) => theme.colors.primaryRed400};
            }

            .mensagem-sucesso {
                color: ${({ theme }) => theme.colors.secondaryGreen400};
            }
        }
    }

    .acoes {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        button {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.2s ease;

            &:hover {
                transform: scale(1.1);
                background-color: rgba(0, 0, 0, 0.05);
            }

            &:active {
                transform: scale(0.95);
            }
        }

        .carregando {
            animation: girar 1s linear infinite;
        }
    }

    @keyframes girar {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const BarraProgresso = styled.div<{ $progresso: number }>`
    display: flex;
    align-items: center;
    gap: 10px;

    .trilha {
        flex: 1;
        height: 8px;
        background-color: ${({ theme }) => theme.colors.interfaceGray100 || "#e5e7eb"};
        border-radius: 4px;
        overflow: hidden;

        .preenchimento {
            height: 100%;
            width: ${({ $progresso }) => $progresso}%;
            background-color: ${({ theme }) => theme.colors.primaryRed400 || "#ef4444"};
            transition: width 0.3s ease;
            border-radius: 4px;
        }
    }

    .percentual {
        font-size: 11px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryRed400 || "#ef4444"};
        min-width: 35px;
        text-align: right;
    }
`;

export const CartaoAnexo = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 25px 1fr auto;
    align-items: center;
    gap: 5px;
    padding: 15px 20px 15px 15px;
    border-radius: 6px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);

    @media (max-width: 640px) {
        align-items: flex-start;
    }

    .icone {
        svg {
            width: 18px;
            height: 18px;
        }
    }

    .conteudo {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .cabecalho {
            display: flex;
            align-items: center;
            gap: 10px;

            @media (max-width: 640px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
            }

            .nome {
                font-size: 13px;
                font-weight: 600;
                color: ${({ theme }) => theme.colors.interfaceText400};
                word-break: break-word;
            }

            .extensao {
                background-color: ${(props: any) => props.theme.colors.interfacePure0};
                color: ${(props: any) => props.theme.colors.c374151};
                padding: 3px 8px;
                border-radius: 12px;
                box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
                font-size: 10px;
                font-weight: 500;
            }
        }

        .detalhes {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 4px;
            font-size: 11px;
            color: ${({ theme }) => theme.colors.interfaceGray400};

            @media (max-width: 800px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;

                svg {
                    display: none;
                }
            }

            .responsavel {
                display: flex;
                align-items: center;
                gap: 5px;
            }

            .etiqueta {
                padding: 3px 8px;
                border-radius: 12px;
                font-size: 10px;
                font-weight: 500;
                background-color: rgb(252, 230, 230);
                color: rgb(239, 68, 68);
                text-transform: capitalize;
            }
        }
    }

    .acao-download {
        cursor: pointer;
        padding: 10px;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;

        &:hover {
            background-color: ${({ theme }) => theme.colors.interfacePure100};
        }

        svg {
            width: 18px;
            height: 18px;
        }

        .carregando {
            animation: girar 1s linear infinite;
        }
    }
`;

export const ListaVazia = styled.div`
    width: 100%;
    padding: 24px;
    border-radius: 8px;
    border: 1px dashed ${({ theme }) => theme.colors.interfaceGray200};
    text-align: center;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    font-size: 13px;
    font-weight: 500;
`;

